
import { mergeMap, map, take } from 'rxjs/operators'
import { EpicRefined } from 'interfaces/middleware'
import { combineEpics } from 'redux-observable'
import { of, merge, race } from 'rxjs'
import FloatingPaneAction, { modifyFloatingPaneActionCreator, killFloatingPanesActionCreator } from 'actions/floatingPanesActions'
import { filterRequestOfType, filterRequest } from 'rxOperators/filterRequestOfType'
import {
  CREATE_STRIPE_PAYMENT_METHOD,
  createStripePaymentMethodActionCreator,
  PATCH_STRIPE_PAYMENT_METHOD,
  patchStripePaymentMethodActionCreator,
} from 'actions/stripeActions'
import { SubscriptionAction, CreateSubscriptionAction, PatchSubscriptionAction } from 'actions/subscriptionActions'
import { isMemberPremiumSelector } from 'selectors/globalSelectors'

const createSubscription: EpicRefined<SubscriptionAction | FloatingPaneAction> = (action$, store) => action$.pipe(
  filterRequest(CreateSubscriptionAction.type),
  mergeMap((action) => {

    const success$ = action$.pipe(
      filterRequestOfType(CREATE_STRIPE_PAYMENT_METHOD, 'success'),
      take(1),
      mergeMap(() => {
        const state = store.getState()
        const isSubscribed = isMemberPremiumSelector(state)
        if (isSubscribed) {
          return merge(
            of(action.success()),
            of(modifyFloatingPaneActionCreator('subscription', {
              mode: 'done',
            }))
          )
        }

        return of(action.success())
      }),
    )

    const fail$ = action$.pipe(
      filterRequestOfType(CREATE_STRIPE_PAYMENT_METHOD, 'fail'),
      take(1),
      map(() => action.fail()),
    )

    return merge(
      race(
        success$,
        fail$,
      ),
      of(createStripePaymentMethodActionCreator.request(action.payload.params))
    )
  }),
  map((action) => action as any as SubscriptionAction)
)

const patchSubscription: EpicRefined<SubscriptionAction | FloatingPaneAction> = (action$) => action$.pipe(
  filterRequest(PatchSubscriptionAction.type),
  mergeMap((action) => {

    const success$ = action$.pipe(
      filterRequestOfType(PATCH_STRIPE_PAYMENT_METHOD, 'success'),
      take(1),
      mergeMap(() => merge(
        of(action.success()),
        of(killFloatingPanesActionCreator('subscription')),
      )),
    )

    const fail$ = action$.pipe(
      filterRequestOfType(PATCH_STRIPE_PAYMENT_METHOD, 'fail'),
      take(1),
      map(() => action.fail()),
    )

    return merge(
      race(
        success$,
        fail$,
      ),
      of(patchStripePaymentMethodActionCreator.request(action.payload.params))
    )
  }),
  map((action) => action as any as SubscriptionAction)
)

export const subscription2Epic = combineEpics(
  createSubscription,
  patchSubscription,
)
